<script lang="ts">
	import { themeStore, type ThemePreference } from '$lib/stores/theme.svelte';

	const order: Record<ThemePreference, ThemePreference> = {
		light: 'dark',
		dark: 'system',
		system: 'light'
	};

	const labels: Record<ThemePreference, string> = {
		light: 'Light theme (click for dark)',
		dark: 'Dark theme (click for system)',
		system: 'System theme (click for light)'
	};
</script>

<button
	type="button"
	onclick={() => themeStore.set(order[themeStore.preference])}
	aria-label={labels[themeStore.preference]}
	title={labels[themeStore.preference]}
	class="flex items-center justify-center w-11 h-11 min-h-11 rounded-lg text-ak-text-secondary hover:text-ak-wintergreen hover:bg-ak-surface active:bg-ak-surface-overlay active:scale-[0.95] transition-colors will-change-colors touch-manipulation"
>
	{#if themeStore.preference === 'light'}
		<!-- Sun -->
		<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M12 3v2m0 14v2m9-9h-2M5 12H3m15.364 6.364l-1.414-1.414M7.05 7.05L5.636 5.636m12.728 0L16.95 7.05M7.05 16.95l-1.414 1.414M16 12a4 4 0 11-8 0 4 4 0 018 0z"
			/>
		</svg>
	{:else if themeStore.preference === 'dark'}
		<!-- Moon -->
		<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
			/>
		</svg>
	{:else}
		<!-- System / monitor -->
		<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
			/>
		</svg>
	{/if}
</button>
